module.exports = __webpack_public_path__ + "img/20.9.TU.29f17a3a.png";